export default __webpack_public_path__ + "static/media/connect_with_bank.ccc5e746.svg";